import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";

const Saved = (props) => {
    const { movieWatchlist } = useContext(GlobalContext);
    const { serieWatchlist } = useContext(GlobalContext);
    const { bookReadlist } = useContext(GlobalContext);

    const { removeMovieFromWatchlist, removeSerieFromWatchlist, removeBookFromBookshelf, addMovieToDone, addSerieToDone, addBookToDone } = useContext(GlobalContext);
    return (
        <div className="savedList">
            <h1>Saved Movies</h1>
            {movieWatchlist.length > 0 ? (
                <div className="list">
                    {movieWatchlist.map(movie => (
                        <div className="cardContainer">
                            <img src={"https://image.tmdb.org/t/p/w500" + movie.poster_path} alt="" />
                            <h2 data-id={movie.id}>{movie.title}</h2>
                            <button className="btn-warning" onClick={() => {addMovieToDone(movie); removeMovieFromWatchlist(movie.id)}}>Add to Done</button>
                            <button className="btn-warning" onClick={() => removeMovieFromWatchlist(movie.id)}>Remove from Saved</button>
                        </div>
                    ))}
                </div>
            ) : (
                <h2 className="noBooks">No Movies in the watchlist</h2>
            )}
            <h1>Saved Series</h1>
            {serieWatchlist.length > 0 ? (
                <div className="list">
                    {serieWatchlist.map(serie => (
                        <div className="cardContainer">
                            <img src={"https://image.tmdb.org/t/p/w500" + serie.poster_path} alt="" />
                            <h2 data-id={serie.id}>{serie.name}</h2>
                            <button className="btn-warning" onClick={() => {addSerieToDone(serie); removeSerieFromWatchlist(serie.id)}}>Add to Done</button>
                            <button className="btn-warning" onClick={() => removeSerieFromWatchlist(serie.id)}>Remove from Saved</button>
                        </div>
                    ))}
                </div>
            ) : (
                <h2 className="noBooks">No Series in the watchlist</h2>
            )}
            <h1>Saved Books</h1>
            {bookReadlist.length > 0 ? (
                <div className="list">
                    {bookReadlist.map(book => (
                        <div className="cardContainer">
                            <div className="overlay"></div>

                            <img src={book.volumeInfo.imageLinks.thumbnail} alt="" />
                            <h2>{book.volumeInfo.title}</h2>
                            <button className="btn-warning" onClick={() => addBookToDone(book)} >Add to Done</button>
                            <button className="btn-warning" onClick={() => removeBookFromBookshelf(book.id)}>Remove from Saved</button>
                        </div>
                    ))}
                </div>
            ) : (
                <h2 className="noBooks">No Books on the bookshelf</h2>
            )}
        </div>
    );
};

export default Saved;